module.exports = __webpack_public_path__ + "static/4-9de25c187927d5fd0516c45de895108d.png";